import React from 'react';
import axios from 'axios';

import { Link } from 'react-router-dom';

import Loading from './Loading';

import styles from '../styles/DynamicModal.module.css';

const ProfileModal = ({ closeModal, openChangeProfileDataModal }) => {
    const [user, setUser] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        document.body.style.overflow = 'hidden';
    
        return () => {
          document.body.style.overflow = '';
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/user', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                if (response.data.approval !== 'Активен') { handleLogout() };
                setUser(response.data);
                setLoading(false);
            }).catch(err => {
                console.error('Ошибка получения данных '+err);
                setWarning('Ошибка получения данных: '+err.response.data);
                setLoading(false);
            });
        } else {
            handleLogout();
        }
    }, [])


    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <form className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Профиль</h1>
                    <svg onClick={closeModal} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                <div className={styles.main}>
                    <div className={styles.profile}>
                        {loading ? (
                            <Loading />
                        ) : warning ? (
                        <>
                            <a>{warning}</a>
                        </>
                        ) 
                        : 
                        (
                        <>
                            <h3>{user.lastname} {user.firstname} {user.surname}</h3>
                            <h3>{user.email}</h3>
                            <a style={{cursor: 'text', fontSize: '16px'}}>Регион: {user.branch}</a>
                            <a style={{cursor: 'text', fontSize: '16px', marginBottom: '20px'}}>Тип учётной записи: {user.role}</a>
                            <a className='button maxWidth' onClick={openChangeProfileDataModal}>Изменить данные</a>
                            <a className='button red maxWidth' href='/auth/logout'>Выйти</a>
                            <Link className={styles.labelForPolicy} to='/privacy-policy'>Пользовательское соглашение и политика конфиденциальности</Link>
                        </>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ProfileModal;
